import * as React from 'react'
import { observer } from 'mobx-react-lite'
import { Filter, InvoiceFilter } from '../../FilterStore'
import { CreateInvoiceList } from '../..'
import { message } from 'antd'
import { parseErrorMsg, parseAndDownloadCSV } from '../../../../../utilities/helpers'
import { BlazeButton } from '../../../../../components/CustomButtons/BlazeButton'

interface Props {
  createInvoiceList: CreateInvoiceList
  invoiceFilter: Filter
  widthBreakPoint?: number
}

export const ExportInvoiceButton = observer((props: Props) => {
  const { createInvoiceList, invoiceFilter, widthBreakPoint } = props
  const invoiceFilterWithLargeLimit: InvoiceFilter = {
    ...invoiceFilter.networkObject,
    limit: 999999,
    offset: 0,
  }

  const [isLoading, setIsLoading] = React.useState(false)

  const exportAsCsv = async () => {
    setIsLoading(true)

    try {
      const paginatedInvoices = await createInvoiceList.fetchInvoices(invoiceFilterWithLargeLimit)

      createInvoiceList.setPaginatedInvoices(paginatedInvoices)

      parseAndDownloadCSV('Purchase Orders', createInvoiceList.invoicesInCsv)
    } catch (error) {
      message.error(parseErrorMsg(error) || 'There was an error getting invoices')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <BlazeButton
      buttonProps={{
        icon: 'download',
        disabled: isLoading,
        loading: isLoading,
        onClick: exportAsCsv,
      }}
      titleProps={{
        title: 'Export',
        widthBreakPoint,
      }}
    />
  )
})
